<template>
  <div
    class="absolute z-10 bg-white-100/60 dark:bg-black/60 flex items-center justify-center gap-2 w-full h-full invisible group-hover:visible"
  >
    <slot />
  </div>
</template>
